import { Button, Grid, Box as MuiBox, Typography, Link } from '@mui/material';

interface MessageBoxType {
  title: string | JSX.Element;
  subtitle?: string | JSX.Element;
  image: string;
  fullWidth?: boolean;
  welcomePage?: boolean;
}

const MessageBox = ({ image, title, subtitle, fullWidth, welcomePage }: MessageBoxType) => {
  return (
    <MuiBox
      display="flex"
      justifyContent="center"
      height={{ xs: 'auto' }}
      width="100%"
    >
      <Grid
        container
        padding={2}
        borderRadius={2}
        bgcolor="background.secondary"
        width={fullWidth ? { xs: '100%' } : { xs: '100%', lg: '800px' }}
        display="flex"
        justifyContent="space-between"
        spacing={2}
        flexDirection={{ xs: 'column', md: 'row' }}
        flexWrap="nowrap"
        margin={welcomePage ? 1 : 0}
      >
        <Grid
          container
          item
          textAlign="left"
          spacing={1}
          display="flex"
          flexDirection={{ xs: 'column', lg: 'row' }}
          flexWrap="nowrap"
          padding="16px"
        >
          <Grid item xs={2} padding={0}>
            <MuiBox
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
              width={{ xs: '50px', lg: '100%' }}
            >
              <img src={image} height="64px" width="64px" alt="Logomark" />
            </MuiBox>
          </Grid>
          <Grid
            item
            xs={10}
            display="flex"
            justifyContent="center"
            alignItems="flex-start"
            flexDirection="column"
          >
            <Typography variant="h6">{title}</Typography>
            <Typography variant="body1">
              {subtitle ||
              welcomePage ?
                <span>
                  Email us at
                  {' '}
                  <a
                    href="mailto: ri@theguarantors.com"
                    style={{ color: 'inherit' }}
                  >
                    ri@theguarantors.com
                  </a>
                  .
                </span>
                :
                <span>
                  Contact us or review our&nbsp;
                  <Link
                    href="https://www.theguarantors.com/faq-for-renters?slug=renter"
                    style={{ color: 'inherit', fontWeight: '400' }}
                    underline="always"
                  >
                    FAQs
                  </Link>
                  .
                </span>
              }
            </Typography>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          md={5}
          display="flex"
          justifyContent={{ xs: 'flex-start', md: 'center' }}
          alignItems={{ xs: 'flex-start', md: 'center' }}
        >
          <Button
            variant="contained"
            sx={{ bgcolor: 'transparent', color: 'inherit' }}
            onClick={()=>welcomePage
              ? window.open("https://help.theguarantors.com/renters-insurance")
              : window.open(`tel:+12122660020`)
            }
          >
            {welcomePage ? 'FAQs' : 'Contact Us'}
          </Button>
        </Grid>
      </Grid>
    </MuiBox>
  );
};

export default MessageBox;
